import { Banner } from '@kc-console/common-ui';
import {
  CONSOLE_VERSION,
  SERVICE_MIGRATION_STATUS,
  useModal,
  useServiceAppState,
  useUserPreferenceQuery,
} from '@kc-console/context';
import { useTranslation } from '@kc-console/core';
import { IcSettingType1Regular } from '@kep/kcds-icons';

import { useConsoleVersionBannerStorage } from '../../hooks';
import { UpdateConsoleVersionModal } from '../../modals';
/**
 * 콘솔 버전(구/신) 안내용 배너.
 * common-ui Banner를 재사용하며, 새 콘솔 전용 서비스 안내 문구와 "새로운 콘솔 사용하기" 버튼을 노출합니다.
 * 버튼 클릭 시 UpdateConsoleVersionModal을 엽니다.
 * consoleVersion이 UR이면서 serviceMigrationStatus가 CUTOVER(BD만 가능)일 때만 노출합니다.
 * 한 번 닫으면 서비스별로 localStorage에 기록되어 1주 동안만 숨겨집니다.
 *
 * @description
 * - category: info, hierarchy: low (Figma 스펙)
 */
const ConsoleVersionBanner = () => {
  const { t } = useTranslation();
  const {
    state: { serviceKeyword },
  } = useServiceAppState();
  const { data: userPreference } = useUserPreferenceQuery();
  const { shouldShow: shouldShowBanner, setHideForAWeek } =
    useConsoleVersionBannerStorage(serviceKeyword);
  const { openModal } = useModal();

  const shouldShow =
    userPreference &&
    userPreference.consoleVersion === CONSOLE_VERSION.UR &&
    userPreference.serviceMigrationStatus === SERVICE_MIGRATION_STATUS.CUTOVER &&
    shouldShowBanner;

  if (!shouldShow) {
    return null;
  }

  const handleOpenConsoleVersionModal = () => {
    openModal({
      Component: UpdateConsoleVersionModal,
    });
  };

  return (
    <Banner
      category="info"
      hierarchy="low"
      buttonProps={{
        label: t('layout:console_version.banner.button.label'),
        startIcon: <IcSettingType1Regular fontSize={20} />,
        onClick: handleOpenConsoleVersionModal,
      }}
      onClose={setHideForAWeek}
    >
      {t('layout:console_version.banner.description')}
    </Banner>
  );
};

ConsoleVersionBanner.displayName = 'ConsoleVersionBanner';

export default ConsoleVersionBanner;
